/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_ConnectingInputs */



/**
* | output |
* | --- |
* | "Connecting to Ateliere Connect..." |
*
* @param {Ateliere_Connect_Status_ConnectingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_connecting = /** @type {((inputs?: Ateliere_Connect_Status_ConnectingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_ConnectingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion à Ateliere Connect...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung zu Ateliere Connect herstellen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connessione ad Ateliere Connect...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключение к Ateliere Connect...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conectándose a Ateliere Connect...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在连接到 Atelier Connect...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Ateliere Connectに接続しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एटेलियर कनेक्ट से जुड़ रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conectando-se ao Ateliere Connect...")
	return /** @type {LocalizedString} */ ("Connecting to Ateliere Connect...")
});